'use client'
import React, { useEffect } from "react";
// import Image from "next/image";
import "./header.css";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faArrowRightToBracket } from '@fortawesome/free-solid-svg-icons'
// import { FaHeadphones } from "react-icons/fa6";
import { FaBars, FaXmark, FaChevronDown, FaChevronRight, FaChevronUp, FaArrowLeft } from "react-icons/fa6";
import urlList from "@/urlList";
import axios from "axios";
import Button from "@/app/components/Button/Button";


async function saveJourney(body: any[]) {
  const journeyId = typeof window !== 'undefined' ? localStorage.getItem('journeyId') : null;

  const params = new URLSearchParams({
    isBeforeLogin: 'true',
  });
  if (journeyId) {
    params.append('journeyId', journeyId);
  }

  try {
    const response = await fetch(`${urlList.SAVE_USER_JOURNEY}?${params.toString()}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error('Request failed');
    }

    const result = await response.json();
    return result;
  } catch (err) {
    console.error('saveJourney error:', err);
  }
}

function startJourney(type?: string) {
  const body = [{
    source: type ?? 'Share Your Requirements',
    description: typeof window !== 'undefined' ? window.location.href : '',
    action: 'CLICK'
  }];
  saveJourney(body);
}


function Header({ showPartner = false }: { showPartner?: boolean }) {
  const [activeDropdown, setActiveDropdown] = React.useState('');
  const [activeSubmenu, setActiveSubmenu] = React.useState('');
  const [showHeaderMenu, setShowHeaderMenu] = React.useState(false);
  const [mobileActiveDropdown, setMobileActiveDropdown] = React.useState('');
  const [categoryList, setCategoryList] = React.useState<any[]>([]);
  const [industryList, setIndustryList] = React.useState<any[]>([]);


  const fetchCategoryList = async () => {
    try {
      const response: any = await axios.get(`${urlList.GET_ALL_CATEGORY}`);
      const data = response?.data?.data || [];
      const trimmed = data
        .map((cat: any) => ({
          categoryName: cat.categoryName,
          displayName: cat.displayName,
          visibleOnHomePage: cat.visibleOnHomePage,
          areaOfWorkName: (cat.areaOfWorkName || []).map((aow: any) => ({
            publishedUrl: aow.publishedUrl,
            displayAreaName: aow.displayAreaName,
            areaName: aow.areaName,
          })),
        }))
        .filter((cat: any) => cat.areaOfWorkName.length > 0);
      setCategoryList(trimmed);
    } catch (err) {
      console.error('fetchCategoryList error:', err);
    }
  };

  const fetchIndustryList = async () => {
    try {
      const response: any = await axios.get(`${urlList.GET_INDUSTRY_SECTORS}`);
      if (response?.data?.isSuccess) {
        const trimmed = (response.data.data || []).map((sector: any) => ({
          displayName: sector.displayName,
          industries: (sector.industries || []).map((ind: any) => ({
            publishedUrl: ind.publishedUrl,
            industryDisplayName: ind.industryDisplayName,
          })),
        }));
        setIndustryList(trimmed);
      }
    } catch (err) {
      console.error('fetchIndustryList error:', err);
    }
  };

  useEffect(() => {
    fetchCategoryList();
    fetchIndustryList();
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const handleOutsideClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest('.nav-group-wrapper') && !target.closest('.headerMenu')) {
        setActiveDropdown('');
        setActiveSubmenu('');
      }
    };
    document.addEventListener('click', handleOutsideClick);
    return () => document.removeEventListener('click', handleOutsideClick);
  }, []);

  const toggleDropdown = (menu: string) => {
    setActiveDropdown(prev => prev === menu ? '' : menu);
    setActiveSubmenu('');
  };

  const toggleSubmenu = (item: string, e: React.MouseEvent) => {
    e.stopPropagation();
    setActiveSubmenu(prev => prev === item ? '' : item);
  };

  const expertiseList = categoryList.filter((el: any) => el.visibleOnHomePage);
  const colSize = Math.ceil(expertiseList.length / 3);
  const indColSize = Math.ceil(industryList.length / 3);

  return (
    <>
      {/* ── OLD IMPLEMENTATION ──
      <div className="fixed top-0 left-0 shadow bg-white h-[4.5rem] flex justify-between items-center w-full px-[3.5vw] py-3 z-[999] lg:h-[11vh] lg:py-[2vw]">

        <a href={`/`} className="min-h-[1rem]">
          <Image
            loader={() => customLoader(imageUrl)}
            alt="Oodles Logo"
            src={imageUrl}
            className="w-[6rem] h-[2.5rem] lg:w-[10vw] lg:h-[3.7vw]"
            width="100"
            height="20"
          />
        </a>

        <div className="flex gap-4 justify-center items-center ">
          <div className="flex gap-6 headerHide ">
            <a href="/fields-of-work" className="text-[#707070] text-[0.8rem] cursor-pointer font-bold homeNav">Expertise</a>
            <a href="/discover-your-specialist" className="text-[#707070] text-[0.8rem] cursor-pointer font-bold homeNav">Specialist</a>
            <a href="/industries" className="text-[#707070] text-[0.8rem] cursor-pointer font-bold homeNav">Industries</a>
            <a href="/insights" className="text-[#3083c5] text-[0.8rem] cursor-pointer font-bold homeNav">Insights</a>
            {showPartner ? (<a href="/partner" className="text-[#707070] text-[0.8rem] cursor-pointer font-bold homeNav">Partners</a>) : null}
            <a href="/#faq" className="text-[#707070] text-[0.8rem] cursor-pointer font-bold homeNav">FAQs</a>
          </div>
        </div>

        <div className="flex justify-center items-center gap-4 cursor-pointer rightSection">
          <a className="flex needExpert" href="/onboarding" onClick={()=>{startJourney('Get a Free Quote')}}>
            <FaHeadphones />
            <div className="font-semibold needExpertText">Get a Free Quote</div>
          </a>
          <a className="flex justify-center items-center login gap-[0.2rem] cursor-pointer" href="/client/login">
            <div>Log In</div>
            <FontAwesomeIcon icon={faArrowRightToBracket} />
          </a>
        </div>
      </div>

      <a className="cta inline-flex items-center" href="/onboarding" onClick={() => { startJourney('Share Your Requirements') }}>
        <img src="https://d3pobbnt1x9ww1.cloudfront.net/oodles-files/newimg.png" alt="AI icon" className="w-5 h-auto" />
        <span>Share Your Requirements</span>
      </a>
      ── END OLD IMPLEMENTATION ── */}

      {/* ── NEW IMPLEMENTATION ── */}
      <div className="header">
        <div className="header-logo-container">
          <button className="hamburger-btn" onClick={() => setShowHeaderMenu(true)} aria-label="Open menu">
            <FaBars />
          </button>
          <a href="/" className="header-logo">
            <img src="https://d2a2ewayv7zdze.cloudfront.net/oodles-static-asset/oodles-logo.svg" alt="Oodles Logo" />
          </a>
        </div>

        {/* Desktop nav */}
        <div className="headerInRight">

          {/* Expertise dropdown */}
          <div className="nav-group-wrapper">
            <div className="nav-group" onClick={() => toggleDropdown('expertise')}>
              <span className={`navStyle${activeDropdown === 'expertise' ? ' navStyle1' : ''}`}>Expertise</span>
              <div className={`icon-container${activeDropdown === 'expertise' ? ' icon-rotated' : ''}`}>
                <FaChevronDown />
              </div>
            </div>
            {activeDropdown === 'expertise' && (
              <div className="nav-dropdown">
                <div className="submenu">
                  {[
                    expertiseList.slice(0, colSize),
                    expertiseList.slice(colSize, colSize * 2),
                    expertiseList.slice(colSize * 2),
                  ].map((col, colIdx) => (
                    <div className="submenu-col" key={colIdx}>
                      {col.map((item: any) => (
                        <div className="submenu-item-wrapper" key={item.categoryName}>
                          <div
                            className={`submenu-item${activeSubmenu === item.categoryName ? ' submenu-item-active' : ''}`}
                            onClick={(e) => toggleSubmenu(item.categoryName, e)}
                          >
                            <span>{item.displayName || item.categoryName}</span>
                            <div className="sub-icon">
                              <FaChevronRight className={activeSubmenu === item.categoryName ? 'submenu-icon-active' : ''} />
                            </div>
                          </div>
                          {activeSubmenu === item.categoryName && (
                            <div className="sub-dropdown">
                              <div className="sub-menu-container">
                                {item.areaOfWorkName.map((area: any) => (
                                  <a key={area.publishedUrl} className="sub-dropdown-item" href={area.publishedUrl}>
                                    {area.displayAreaName || area.areaName}
                                  </a>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Industries dropdown */}
          <div className="nav-group-wrapper">
            <div className="nav-group" onClick={() => toggleDropdown('industries')}>
              <span className={`navStyle${activeDropdown === 'industries' ? ' navStyle1' : ''}`}>Industries</span>
              <div className={`icon-container${activeDropdown === 'industries' ? ' icon-rotated' : ''}`}>
                <FaChevronDown />
              </div>
            </div>
            {activeDropdown === 'industries' && (
              <div className="nav-dropdown">
                <div className="submenu">
                  {[
                    industryList.slice(0, indColSize),
                    industryList.slice(indColSize, indColSize * 2),
                    industryList.slice(indColSize * 2),
                  ].map((col, colIdx) => (
                    <div className="submenu-col" key={colIdx}>
                      {col.map((sector: any) => (
                        <div className="submenu-item-wrapper" key={sector.displayName}>
                          <div
                            className={`submenu-item${activeSubmenu === sector.displayName ? ' submenu-item-active' : ''}`}
                            onClick={(e) => toggleSubmenu(sector.displayName, e)}
                          >
                            <span>{sector.displayName}</span>
                            <div className="sub-icon">
                              <FaChevronRight className={activeSubmenu === sector.displayName ? 'submenu-icon-active' : ''} />
                            </div>
                          </div>
                          {activeSubmenu === sector.displayName && (
                            <div className="sub-dropdown">
                              <div className="sub-menu-container">
                                {sector.industries.map((industry: any) => (
                                  <a key={industry.publishedUrl} className="sub-dropdown-item" href={industry.publishedUrl}>
                                    {industry.industryDisplayName}
                                  </a>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {showPartner && <a href="/partner" className="navStyle">Partners</a>}
          <a href="/#faq" className="navStyle">FAQs</a>
        </div>

        <div className="rightSection">
          <Button label="Login" variant="outlined" href="/client/login" />
          <Button label="Get a Quote" variant="filled" href="/contact-us" onClick={() => startJourney('Get a Quote')} />
        </div>
      </div>

      {/* ── MOBILE: Level 1 Offcanvas ── */}
      <div className={`headerMenu${showHeaderMenu ? ' open' : ''}`}>
        <div className="offcanvas-header">
          <a href="/" className="header-logo">
            <img src="https://d2a2ewayv7zdze.cloudfront.net/oodles-static-asset/oodles-logo.svg" alt="Oodles Logo" />
          </a>
          <div className="cross-container" onClick={() => setShowHeaderMenu(false)}>
            <FaXmark />
          </div>
        </div>
        <div className="offcanvas-body">
          <div className="offcanvas-menus">
            <div className="offcanvas-menu-item" onClick={() => { setShowHeaderMenu(false); setMobileActiveDropdown('expertise'); }}>
              <h4 className="ds-body">Expertise</h4>
              <div className="dropdown-icon"><FaChevronRight /></div>
            </div>
            <div className="offcanvas-menu-item" onClick={() => { setShowHeaderMenu(false); setMobileActiveDropdown('industries'); }}>
              <h4 className="ds-body">Industries</h4>
              <div className="dropdown-icon"><FaChevronRight /></div>
            </div>
            {showPartner && (
              <a href="/partner" className="offcanvas-menu-item" onClick={() => setShowHeaderMenu(false)}>
                <h4 className="ds-body">Partners</h4>
              </a>
            )}
            <a href="/#faq" className="offcanvas-menu-item" onClick={() => setShowHeaderMenu(false)}>
              <h4 className="ds-body">FAQs</h4>
            </a>
          </div>
          <div className="offcanvas-login">
            <Button customClass="offcanvas-btn" label="Login" variant="outlined" href="/client/login" />
          </div>
        </div>
      </div>

      {/* ── MOBILE: Expertise Offcanvas (Level 2) ── */}
      {mobileActiveDropdown === 'expertise' && (
        <div className="headerMenu open">
          <div className="offcanvas-header">
            <a href="/" className="header-logo">
              <img src="https://d2a2ewayv7zdze.cloudfront.net/oodles-static-asset/oodles-logo.svg" alt="Oodles Logo" />
            </a>
            <div className="cross-container" onClick={() => { setMobileActiveDropdown(''); setActiveSubmenu(''); }}>
              <FaXmark />
            </div>
          </div>
          <div className="offcanvas-body">
            <div className="dropdown-menus">
              <div className="back-submenu" onClick={() => { setMobileActiveDropdown(''); setActiveSubmenu(''); setShowHeaderMenu(true); }}>
                <div className="back-icon"><FaArrowLeft /></div>
                <p className="ds-para">Back</p>
              </div>
              <div className="offcanvas-section-title">
                <h4 className="ds-body ds-gray-500">Expertise</h4>
                <div className="dropdown-icon submenu-opened"><FaChevronUp /></div>
              </div>
              {categoryList.slice(1).map((item: any) => (
                <div className="submenu-item-wrapper" key={item.categoryName}>
                  <div className="offcanvas-submenu-row" onClick={(e) => toggleSubmenu(item.categoryName, e)}>
                    <h5 className="ds-para">{item.displayName || item.categoryName}</h5>
                    <div className="sub-icon offcanvas-sub-icon">
                      <FaChevronRight className={activeSubmenu === item.categoryName ? 'submenu-icon-active' : ''} />
                    </div>
                  </div>
                  {activeSubmenu === item.categoryName && (
                    <div className="sub-dropdown offcanvas-sub-dropdown">
                      <div className="sub-menu-container">
                        {item.areaOfWorkName.map((area: any) => (
                          <a key={area.publishedUrl} className="sub-dropdown-item" href={area.publishedUrl}>
                            {area.displayAreaName || area.areaName}
                          </a>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="offcanvas-login">
              <Button customClass="offcanvas-btn" label="Login" variant="outlined" href="/client/login" />
            </div>
          </div>
        </div>
      )}

      {/* ── MOBILE: Industries Offcanvas (Level 2) ── */}
      {mobileActiveDropdown === 'industries' && (
        <div className="headerMenu open">
          <div className="offcanvas-header">
            <a href="/" className="header-logo">
              <img src="https://d2a2ewayv7zdze.cloudfront.net/oodles-static-asset/oodles-logo.svg" alt="Oodles Logo" />
            </a>
            <div className="cross-container" onClick={() => { setMobileActiveDropdown(''); setActiveSubmenu(''); }}>
              <FaXmark />
            </div>
          </div>
          <div className="offcanvas-body">
            <div className="dropdown-menus">
              <div className="back-submenu" onClick={() => { setMobileActiveDropdown(''); setActiveSubmenu(''); setShowHeaderMenu(true); }}>
                <div className="back-icon"><FaArrowLeft /></div>
                <p className="ds-para">Back</p>
              </div>
              <div className="offcanvas-section-title">
                <h4 className="ds-body ds-gray-500">Industries</h4>
                <div className="dropdown-icon submenu-opened"><FaChevronUp /></div>
              </div>
              {industryList.map((sector: any) => (
                <div className="submenu-item-wrapper" key={sector.displayName}>
                  <div className="offcanvas-submenu-row" onClick={(e) => toggleSubmenu(sector.displayName, e)}>
                    <h5 className="ds-para">{sector.displayName}</h5>
                    <div className="sub-icon offcanvas-sub-icon">
                      <FaChevronRight className={activeSubmenu === sector.displayName ? 'submenu-icon-active' : ''} />
                    </div>
                  </div>
                  {activeSubmenu === sector.displayName && (
                    <div className="sub-dropdown offcanvas-sub-dropdown">
                      <div className="sub-menu-container">
                        {sector.industries.map((industry: any) => (
                          <a key={industry.publishedUrl} className="sub-dropdown-item" href={industry.publishedUrl}>
                            {industry.industryDisplayName}
                          </a>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="offcanvas-login">
              <Button customClass="offcanvas-btn" label="Login" variant="outlined" href="/client/login" />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Header;
